import styled from 'styled-components';

export const Container = styled.div `
  width: 100%;
  max-width: 100%;
  flex: 0 0 auto;
  height: auto;
  min-height: min-content;
  max-height: none;
  overflow-x: auto;
  overflow-y: visible;

  margin: 0;
  padding: 0.5rem;
  box-sizing: border-box;

  border-radius: 20px;
  background: var(--surface-glass);
  backdrop-filter: blur(18px);
  -webkit-backdrop-filter: blur(18px);
  border: 1px solid var(--border-default);
  box-shadow: var(--shadow-md);
`;

export const StyledTable = styled.table `
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  table-layout: fixed;
`;

export const StyledTableHead = styled.thead `
  background: var(--table-header-bg);

  th:first-child {
    border-top-left-radius: 12px;
  }

  th:last-child {
    border-top-right-radius: 12px;
  }
`;

export const StyledTableRow = styled.tr `
  border-bottom: 1px solid var(--border-subtle); /* Reduzido de 2px para 1px */
  transition: background-color 0.3s;
  color: var(--text-primary);
   height: 56px;
  width: 100%;
`;


export const StyledTableCell = styled.td `
  padding: 6px 8px; /* Reduzido de 12px 10px para 6px 8px */
  text-align: center;
  color: var(--text-primary);
  font-size: 8pt; /* Reduzido de 9pt para 8pt */

  line-height: 1.2; /* Reduzido para linhas mais compactas */
  height: 32px; /* Altura fixa para todas as células */
`;

export const StyledTableHeader = styled.th `
  padding: 6px 8px;
  text-align: center;
  font-weight: var(--table-header-font-weight);
  color: var(--table-header-color);
  font-size: var(--table-header-font-size);
  text-transform: uppercase;
  letter-spacing: var(--table-header-letter-spacing);
  vertical-align: middle;
  line-height: 1.2;
  height: 32px;
`;

export const StyledViewLink = styled.span `
  color: var(--info);
  text-decoration: underline;
  cursor: pointer;
`;

export const StyledButtonVisualizar = styled.button `
  border: 1px solid ${
	props => props.$active ? 'var(--border-subtle)' : 'var(--border-subtle)'
};
  
  background: ${
	props => {
		if (props.$active) {
			return 'var(--surface-1)';
		}
		return 'var(--brand-lime)';
	}
};
  
  color: ${
	props => {
		if (props.$active) {
			return 'var(--text-secondary)';
		}
		return 'var(--text-on-lime)';
	}
};
  
  border-radius: 20px;
  font-size: 10px; /* Reduzido de 12px para 10px */
  font-weight: ${
	props => props.$active ? '600' : '500'
};
  cursor: pointer;
  transition: all 0.2s ease;
  backdrop-filter: ${
	props => props.$active ? 'none' : 'blur(4px)'
};
  box-shadow: var(--shadow-sm);
  display: inline-block;
  font-family: CerebriSans-Regular, -apple-system, system-ui, Roboto, sans-serif;
  padding: 3px 10px; /* Reduzido verticalmente */
  text-align: center;
  text-decoration: none;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  width: auto; /* Mudado de 5vw para auto */
  min-width: 80px; /* Largura mínima */
  height: 28px; /* Altura fixa */
  z-index: 1;
  white-space: nowrap;

  &:hover {
    box-shadow: var(--shadow-md);
    transform: scale(1.05);
  }

  @media screen and (max-width: 768px) {
    font-size: 10px;
    min-width: 60px;
    height: 24px;
    padding: 2px 8px;
  }
`;

export const HoverTR = styled.tr `
  height: 56px;
  border-bottom: 1px solid var(--border-subtle);

  &:hover {
    background: var(--table-row-hover);
  }
`;

export const ButtonContainer = styled.div `
  display: flex;
  gap: 6px; /* Reduzido de 8px para 6px */
  justify-content: center;
  align-items: center;
`;

export const ActionButton = styled.button `
  width: 28px; /* Reduzido de 32px para 28px */
  height: 28px; /* Reduzido de 32px para 28px */
  border: none;
  border-radius: 4px;
  font-size: 14px; /* Reduzido de 16px para 14px */
  font-weight: bold;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  
  ${
	props => props.approve && `
    background-color: var(--success);
    color: var(--text-on-accent);
    
    &:hover {
      background-color: var(--accent-hover);
      transform: scale(1.1);
    }
  `
}
  
  ${
	props => props.reject && `
    background-color: var(--danger);
    color: var(--text-on-accent);
    
    &:hover {
      background-color: var(--danger);
      transform: scale(1.1);
    }
  `
}
  
  &:active {
    transform: scale(0.95);
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
    transform: none;
  }
`;

export const DesktopOnly = styled.div`
  width: 100%;

  @media screen and (max-width: 768px) {
    display: none;
  }
`;

export const MobileCards = styled.div`
  display: none;

  @media screen and (max-width: 768px) {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    width: 100%;
  }
`;

export const MobileCard = styled.article`
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  padding: 0.9rem 1rem;
  border-radius: 14px;
  border: 1px solid var(--border-default);
  background: var(--surface-2);
`;

export const MobileCardTitle = styled.h3`
  margin: 0;
  font-size: 0.95rem;
  font-weight: 700;
  color: var(--text-heading);
`;

export const MobileCardMeta = styled.p`
  margin: 0;
  font-size: 0.8rem;
  color: var(--text-secondary);
  line-height: 1.4;
  word-break: break-word;
`;

export const MobileCardActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-top: 0.35rem;
`;
